import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { change, submit } from 'redux-form';

import { isEmpty } from 'lodash';
import { withRouter } from 'react-router-dom';
import Page from '../../../../shared/components/Page';
import PageContent from '../../../../shared/components/PageContent';
import PageHeader from '../../../../shared/components/PageHeader';

import {
    archiveCollection,
    clearSearchedCollections,
    getCollectionStatus,
    getFilteredCollections,
    getManyCollections,
    getSearchKey,
} from '../../../../shared/actions/index';
import { makeGetObjectsFromStateById, makeGetObjectsFromStateLookup } from '../../../../shared/selectors';

import { RuntimeContext } from '../../../../../common/RuntimeContext';
import CollectionTable from './CollectionTable';

class ManageCollections extends Component {
    static propTypes = {
        getManyCollections: PropTypes.func.isRequired,
        getFilteredCollections: PropTypes.func.isRequired,
        isContentAdmin: PropTypes.bool.isRequired,
        isVerbAdmin: PropTypes.bool.isRequired,
        clearSearchedCollections: PropTypes.func.isRequired,
        submitSearch: PropTypes.func.isRequired,
        archiveCollection: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        viewableCollections: PropTypes.array.isRequired,
        loggedInUser: PropTypes.object
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
          searchKey:  '',
        };
        this.intervalID = ''
    }

    componentDidMount() {
        const promises = [
            this.props.submitSearch(),
            this.props.getManyCollections({ pathsContext: this.context.pathsWeb }),
            this.getPathKey(),
        ];

      this.intervalID = setInterval(this.getPathKey, 3600000);
    
      return Promise.all(promises);
    }

    componentWillUnmount() {
        clearInterval(this.intervalID);
    }

    getPathKey = () => getSearchKey({id: 'wh7rFih2MkcbNrTPkvre'}, this.context.pathsWeb).then(searchKey => this.setState({searchKey}));

    copyCollection = (collection) => {
        const { history } = this.props;

        const copiedCollection = {
            ...collection,
            isActive: false,
            name: `Copy of ${collection.name}`,
            permalink: `copy-of-${collection.permalink}`,
            isCopied: true,
            parentCollectionId: collection._id
        };

        delete copiedCollection._id;
        delete copiedCollection.createdOn;
        delete copiedCollection.updatedOn;
        delete copiedCollection.revision;

        return history.push('/newcollection', {
            isCopied: true,
            copiedCollection
        });
    };

    render() {
        const { isContentAdmin, isVerbAdmin, history, archiveCollection, viewableCollections, clearSearchedCollections, getFilteredCollections } = this.props;
        const collections = viewableCollections.filter(
            (collection) => !collection.isArchived && collection.subscriptionType !== 'ExclusiveCompanyLicense'
        );

        return (
            <Page className={'manage-collections'}>
                <PageHeader title={'Paths'} className={'adminPageHeader'} />
                <PageContent className={'manageTrackV2Wrapper adminWrapper'}>
                    <CollectionTable
                        isContentAdmin={isContentAdmin}
                        isVerbAdmin={isVerbAdmin}
                        history={history}
                        archiveCollection={archiveCollection}
                        viewableCollections={collections}
                        clearSearchedCollections={clearSearchedCollections}
                        getFilteredCollections={getFilteredCollections}
                        getCollectionStatus={getCollectionStatus}
                        copyCollection={this.copyCollection}
                    />
                </PageContent>
            </Page>
        );
    }
}

export const ManageCollectionsComponent = ManageCollections;

const makeMapStateToProps = () => {
    const getCollectionsObjectsFromStateById = makeGetObjectsFromStateById('collections');
    const getCollectionObjectsFromStateLookup = makeGetObjectsFromStateLookup('collections', 'filteredById');
    const mapStateToProps = (state) => {
        const {
            auth: { isVerbAdmin, isContentAdmin, loggedInUser }
        } = state;

        const allCollections = getCollectionsObjectsFromStateById(state);
        const filteredCollections = getCollectionObjectsFromStateLookup(state);
        const viewableCollections = !isEmpty(filteredCollections) ? filteredCollections : allCollections;
        return {
            allCollections,
            viewableCollections,
            isVerbAdmin,
            isContentAdmin,
            loggedInUser
        };
    };

    return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
    getManyCollections: (params) => dispatch(getManyCollections(params)),
    getFilteredCollections: (params) => dispatch(getFilteredCollections(params)),
    clearSearchedCollections: () => dispatch(clearSearchedCollections()),
    submitSearch: () => dispatch(submit('SearchForm')),
    changeFilter: (newFilters) => dispatch(change('SearchForm', 'filters', newFilters)),
    getCollectionStatus: (params) => getCollectionStatus(params),
    archiveCollection: (params) => dispatch(archiveCollection(params))
});

export default withRouter(connect(makeMapStateToProps, mapDispatchToProps)(ManageCollections));
